import { Form, InputNumber, Popconfirm, Table, Typography, Input, Button, Progress, Card, Space, Modal, Empty } from 'antd';
import { RightOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { useState, useRef, useEffect } from 'react';
import { Row, Col } from "react-bootstrap";
import ButtonMui from '@mui/material/Button';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { v4 } from 'uuid'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Highlighter from 'react-highlight-words';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useSelector, useDispatch } from 'react-redux'
import {
    setFile, getFile, setMemberSuccess, getMemberSuccess, setMemberFail, getMemberFail, /* setObjective, */ getStyle, getBizID, getObjective, getFileID, getServices
} from '../../../../libs/todoSlice'
import axios from "axios";
import { useCookies } from "react-cookie";
import { useNavigate, useParams } from 'react-router-dom';
import fontColor from '../../../../lib/fontColor';
import Tooltip from '@mui/material/Tooltip';
import AddDoctorFail from './AddDoctorFail';
import AddDoctorSuccess from './AddDocterSuccess';

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        // {
                        //   // required: true,
                        //   // message: `Please Input ${title}!`,
                        // },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
// end edit table
const AddDoctor = ({ backStep, typeTemplate }) => {
    const [step, setStep] = useState('check');
    const [cookie, setCookie] = useCookies(['account'])
    const dispatch = useDispatch()
    const style = useSelector(getStyle)
    const objective = useSelector(getObjective)
    const [searchvalue, setSearchValue] = useState('')
    const services = useSelector(getServices)
    // function search top
    const [searchParam, setSearchParam] = useState(null);
    const searchFunc = () => {
        if (searchvalue === '') {
            setData(dataDefault)
        }
        else if (searchvalue !== null) {
            var param = dataDefault.filter((items) => {
                if (items.cid !== null && items.cid !== undefined && searchvalue.length === 13) {
                    if (items.cid.substring(6, 13).split(searchvalue.substring(6, 13)).reverse().join('') !== items.cid.substring(6, 13)) {
                        return items
                    }
                }
                // if (items.cid !== null && items.cid !== undefined && searchtext.length === 13) {
                //     if (items.cid.substring(6, 13).split(searchtext.substring(6, 13)).reverse().join('') !== items.cid.substring(6, 13)) {
                //         return items
                //     }
                // }
                if (items.name_th !== null && items.name_th !== undefined) {
                    if (items.name_th.split(searchvalue).reverse().join('') !== items.name_th) {
                        return items
                    }
                }
                if (items.name_eng !== null && items.name_eng !== undefined) {
                    if (items.name_eng.toLowerCase().split(searchvalue).reverse().join('') !== items.name_eng.toLowerCase() || items.name_eng.split(searchvalue).reverse().join('') !== items.name_eng) {
                        return items
                    }
                }
                if (items.cid !== null && items.cid !== undefined) {
                    if (items.cid.split(searchvalue).reverse().join('') !== items.cid) {
                        return items
                    }
                }
                if (items.email !== null && items.email !== undefined) {
                    if (items.email.split(searchvalue).reverse().join('') !== items.email) {
                        return items
                    }
                }
                if (items.tel !== null && items.tel !== undefined) {
                    if (items.tel.split(searchvalue).reverse().join('') !== items.tel) {
                        return items
                    }
                }
                if (items.student_id !== null && items.student_id !== undefined) {
                    if (items.student_id.split(searchvalue).reverse().join('') !== items.student_id) {
                        return items
                    }
                }
                if (items.degree !== null && items.degree !== undefined) {
                    if (items.degree.split(searchvalue).reverse().join('') !== items.degree) {
                        return items
                    }
                }
                if (items.faculty !== null && items.faculty !== undefined) {
                    if (items.faculty.split(searchvalue).reverse().join('') !== items.faculty) {
                        return items
                    }
                }
                if (items.major !== null && items.major !== undefined) {
                    if (items.major.split(searchvalue).reverse().join('') !== items.major) {
                        return items
                    }
                }
                if (items.minor !== null && items.minor !== undefined) {
                    if (items.minor.split(searchvalue).reverse().join('') !== items.minor) {
                        return items
                    }
                }
            })
            setData(param)
        }
    }

    const clearSearch = () => {
        setSearchValue('')
        setData(dataDefault)
    }

    // end function search top

    // function show member
    const member = useSelector(getFile)
    useEffect(() => {
        

        setData(member.map((item, index) => {
            let accountTitleENG = item.title_en
            if (!item.title_en) {
                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                accountTitleENG = title_en_list[title_th_list.indexOf(item.title_th)]
            }
            return {
                index: index + 1,
                status: item.status,
                position: item.position,
                employee_id: item.employee_id,
                organization: item.organization,
                cid: item.cid,
                tel: item.tel,
                student_id: item.student_id,
                email: item.email,
                birth_date: item.birth_date,
                title_th: item.title_th,
                title_special_th: item.title_special_th,
                name_th: item.name_th,
                surname_th: item.surname_th,
                title_en: accountTitleENG,
                title_special_eng: item.title_special_eng,
                name_eng: item.name_eng,
                surname_eng: item.surname_eng,
                key: v4(),
            }
        })
        )
        setDataDefault(member.map((item, index) => {
            let accountTitleENG = item.title_en
            if (!item.title_en) {
                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                accountTitleENG = title_en_list[title_th_list.indexOf(item.title_th)]
            }
            return {
                index: index + 1,
                status: item.status,
                position: item.position,
                employee_id: item.employee_id,
                organization: item.organization,
                cid: item.cid,
                tel: item.tel,
                student_id: item.student_id,
                email: item.email,
                birth_date: item.birth_date,
                title_th: item.title_th,
                title_special_th: item.title_special_th,
                name_th: item.name_th,
                surname_th: item.surname_th,
                title_en: accountTitleENG,
                title_special_eng: item.title_special_eng,
                name_eng: item.name_eng,
                surname_eng: item.surname_eng,
                key: v4(),
            }
        })
        )
    }, [member])
    // end function show member  

    // tab in success step
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const member_fail = useSelector(getMemberFail)
    useEffect(() => {
        if (member_fail.length > 0) {
            setValue('2')
        }
    }, [member_fail]);
    // end tab in success step
    // function steps progress
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['ตรวจสอบข้อมูล', 'กำลังดำเนินการ', 'สำเร็จ'];
    const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 22,
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor:
                    style.primary_color ?? '#053075',
            },
            color: fontColor(style.primary_color)
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor:
                    style.primary_color ?? '#053075',
            },
            color: fontColor(style.primary_color)
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 3,
            border: 0,
            backgroundColor:
                theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
            borderRadius: 1,
        },
    }));
    const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
        border: 'solid',
        borderColor: '#F5F5F5',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#fff',
        zIndex: 1,
        color: '#E0E0E0',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...(ownerState.active && {
            backgroundColor:
                '#F3F5FA',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: style.primary_color ?? '#053075',
        }),
        ...(ownerState.completed && {
            backgroundColor:
                style.primary_color ?? '#053075',
        }),
    }));
    function ColorlibStepIcon(props) {
        const { active, completed, className } = props;
        const icons = {
            1: <FormatListBulletedIcon />,
            2: <HourglassTopIcon />,
            3: <CheckIcon />,
        };
        return (
            <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
                {icons[String(props.icon)]}
            </ColorlibStepIconRoot>
        );
    }
    // end function steps progress

    //function edit table
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [dataDefault, setDataDefault] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({
            index: '',
            title_th: '',
            name_th: '',
            surname_th: '',
            name_eng: '',
            surname_eng: '',
            cid: '',
            address: '',
            tel: '',
            email: '',
            ...record,
        });
        setEditingKey(record.key);
    };
    const save = async (key, not_set = false) => {
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                setData(newData);
                setDataDefault(newData)
                dispatch(setFile({
                    file: newData
                }))
                if (!not_set) {
                    setEditingKey('');
                }
            } else {
                newData.push(row);
                setData(newData);
                dispatch(setFile({
                    file: newData
                }))
                if (!not_set) {
                    setEditingKey('');
                }
            }
        } catch (err) {
        }
    };
    // function delete
    const handleDelete = (key) => {
        const newData = data.filter((item) => {
            return item.key !== key
        });
        setData(newData);
        dispatch(setFile({
            file: newData
        }))
    };
    // end function delete

    // function search
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const navigate = useNavigate()
    const file = useSelector(getFile)
    const fileID = useSelector(getFileID)
    const successList = useSelector(getMemberSuccess)
    const params = useParams()
    const failList = useSelector(getMemberFail)
    const sendExcelSummary = async () => {
        await axios({
            method: 'PATCH',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
            data: {
                _id: fileID,
                total: `${file.length}`,
                success: `${successList.length}`,
                fail: `${failList.length}`,
                successDetail: successList,
                objective: objective,
                failDetail: failList
            }
        }).then(({ data, status }) => {
            // dispatch(setFile({
            //   filename: '',
            //   file: [],
            //   file_id: ''
            // }))
            // dispatch(setMemberFail({
            //   member_fail: []
            // }))
            // dispatch(setMemberSuccess({
            //   member_success: []
            // }))
        }, ({ response }) => {
            const { status } = response
            if (status === 401) {
                navigate(`/${params.prefix}`)
            }
            // dispatch(setFile({
            //   filename: '',
            //   file: [],
            //   file_id: ''
            // }))
            // dispatch(setMemberFail({
            //   member_fail: []
            // }))
            // dispatch(setMemberSuccess({
            //   member_success: []
            // }))
        })
    }


    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                            color: fontColor(style.secondary_color),
                            backgroundColor: style.secondary_color ?? '#053075',
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });
    // end search
    const columns = [
        {
            title: 'ลำดับที่',
            dataIndex: 'index',
            width: 100,
            editable: false,
            fixed: 'left',
            show: true,
            render: (index, __, _) => index
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาไทย)</>),
            dataIndex: 'title_th',
            width: 150,
            show: true,
            // width: '10%',
            // editable: true,
            // ...getColumnSearchProps('title_th'),
            render: (_, record, index) => {
                const editable = isEditing(record);
                // try {
                //   const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                //   const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                //   const title_th = title_th_list[title_en_list.indexOf(record.title_en)] ?? record.title_th
                //   record.title_th = title_th
                // } catch (e) {
                // }
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="title_th">คำนำหน้า</InputLabel>
                        <Select
                            value={record.title_th}
                            labelId='title_th'
                            label="คำนำหน้า"
                            onChange={(e) => {
                                let tempData = [...data]
                                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                                const title_en = title_en_list[title_th_list.indexOf(e.target.value)]
                                tempData[record.index - 1].title_th = e.target.value
                                tempData[record.index - 1].title_en = title_en
                                setData(tempData)
                            }}
                        >
                            <MenuItem value={'นาย'}>นาย</MenuItem>
                            <MenuItem value={'นางสาว'}>นางสาว</MenuItem>
                            <MenuItem value={'นาง'}>นาง</MenuItem>
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'เด็กชาย'}>เด็กชาย</MenuItem>
                                )
                            }
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'เด็กหญิง'}>เด็กหญิง</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                ) : (record.title_th)
            }
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'title_en',
            width: 150,
            show: true,
            // width: '10%',
            // editable: true,
            // ...getColumnSearchProps('title_th'),
            render: (_, record, index) => {
                // try {
                //   const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                //   const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                //   const title_en = title_en_list[title_th_list.indexOf(record.title_th)]?? record.title_en
                //   record.title_en = title_en
                // } catch (e) {

                // }
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="title_en">คำนำหน้า (ภาษาอังกฤษ)</InputLabel>
                        <Select
                            value={record.title_en}
                            labelId='title_en'
                            label="คำนำหน้า (ภาษาอังกฤษ)"
                            onChange={(e) => {
                                let tempData = [...data]
                                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                                const title_th = title_th_list[title_en_list.indexOf(e.target.value)]
                                tempData[record.index - 1].title_en = e.target.value
                                tempData[record.index - 1].title_th = title_th
                                setData(tempData)
                            }}
                        >
                            <MenuItem value={'Mr'}>Mr</MenuItem>
                            <MenuItem value={'Miss'}>Miss</MenuItem>
                            <MenuItem value={'Mrs'}>Mrs</MenuItem>
                            {
                                objective.includes('edu-student-pre-register') && (
                                    <MenuItem value={'Master'}>Master</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                ) : (record.title_en)
            }
        },
        {
            title: 'คำนำหน้านาม',
            dataIndex: 'title_special_th',
            width: 200,
            show: true,
            // width: '10%',
            // editable: true,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="title_special_th">คำนำหน้านาม</InputLabel>
                        <Select
                            value={record.title_special_th}
                            labelId='title_special_th'
                            label="คำนำหน้านาม"
                            onChange={(e) => {
                                record.title_special_th = e.target.value;
                                save(record.key, true)
                            }}
                        >
                            <MenuItem value={'นายแพทย์'}>นายแพทย์</MenuItem>
                            <MenuItem value={'แพทย์หญิง'}>แพทย์หญิง</MenuItem>
                            <MenuItem value={'ทันตแพทย์ชาย'}>ทันตแพทย์ชาย</MenuItem>
                            <MenuItem value={'ทันตแพทย์หญิง'}>ทันตแพทย์หญิง</MenuItem>
                            <MenuItem value={'เภสัชกรหญิง'}>เภสัชกรหญิง</MenuItem>
                            <MenuItem value={'เภสัชกรชาย'}>เภสัชกรชาย</MenuItem>
                        </Select>
                    </FormControl>
                ) : (record.title_special_th)
            }
        },
        {
            title: (<>ชื่อ <br />(ภาษาไทย)</>),
            dataIndex: 'name_th',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>นามสกุล <br />(ภาษาไทย)</>),
            dataIndex: 'surname_th',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('surname_th'),
        },
        {
            title: (<>ชื่อ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'name_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: (<>นามสกุล <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'surname_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('surname_eng'),
        },
        {
            title: 'เลขประจำตัวบุคลากรทางการแพทย์',
            dataIndex: 'employee_id',
            width: 180,
            editable: true,
            // hidden: !objective.includes('Pre-register'),
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: 'ตำแหน่ง',
            dataIndex: 'position',
            width: 150,
            editable: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            show: true
        },
        {
            title: 'ชื่อองค์กร',
            dataIndex: 'organization',
            width: 350,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            show: true
        },
        {
            title: 'เลขประจำตัวประชาชน',
            dataIndex: 'cid',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'โทรศัพท์',
            dataIndex: 'tel',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('tel'),
        },
        {
            title: 'อีเมล',
            dataIndex: 'email',
            width: 250,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('email'),
        },
        {
            title: 'วันเกิด (ปปปป-ดด-วว)',
            dataIndex: 'birth_date',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
            render: (_) => {
                return <>{_}</>
            }
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            width: 200,
            fixed: 'right',
            show: true,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Button
                            type='primary'
                            onClick={() => save(record.key)}
                            style={{
                                marginRight: 8,
                                background: '#53BE35'
                            }}
                        >
                            บันทึก
                        </Button>
                        <Popconfirm title="Sure to cancel?" onConfirm={() => {
                            setEditingKey('');
                            setData(dataDefault)
                        }}>
                            <Button>ยกเลิก</Button>
                        </Popconfirm>
                    </span>
                ) : (
                    <>
                        <Typography.Link /* disabled={editingKey !== ''} */ onClick={() => {
                            edit(record)
                        }}>
                            <ModeEditOutlinedIcon style={{ color: '#053075' }} />
                        </Typography.Link>
                        {data.length >= 1 ? (
                            <Popconfirm title="ต้องการลบข้อมูลนี้ใช่หรือไม่"
                                onConfirm={() =>
                                    handleDelete(record.key)
                                }>
                                <DeleteOutlinedIcon style={{ color: 'red', cursor: 'pointer' }} />
                            </Popconfirm>
                        ) : null
                        }
                    </>
                );
            },
        },
    ].filter(head => !head.hidden && head.show);
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ||
                    col.dataIndex === 'index' ||
                    col.dataIndex === 'no' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    // end edit table

    // function register member
    const importMemberSuccess = useSelector(getMemberSuccess)
    const importMemberFail = useSelector(getMemberFail)
    const [countCA, setcountCA] = useState(0)
    const [count, setcount] = useState(0)
    const [totalMember, setTotalMember] = useState(0)
    const statesuccessone = useSelector(getMemberSuccess)
    const statefailone = useSelector(getMemberFail)
    const [stateAllOne, setStateAllOne] = useState([])
    const [statesuccessca, setStateSuccessCA] = useState([])
    const [statefailca, setStateFailCA] = useState([])
    const business_id = useSelector(getBizID)
    const bizID = useParams()



    const [modalbeforeSuccess, setModalBeforeSuccess] = useState(false);
    const didMountRef = useRef(false);
    const preRegister = async () => {
        let prepare = []
        let prepare_fail = []
        let prepare_data = []
        const nonThaiPattern = /[^ก-๛\s]+/g
        const nonEnglishPattern = /[^A-Za-z\s]+/g;
        prepare_data = member
        for (const index of prepare_data.keys()) {
            const members = prepare_data[index]
            const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
            const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
            const title_en = title_en_list[title_th_list.indexOf(members.title_th)]

            const title_special_th_list = ['นายแพทย์', 'แพทย์หญิง', 'ทันตแพทย์ชาย', 'ทันตแพทย์หญิง', 'เภสัชกรหญิง', 'เภสัชกรชาย']
            const title_special_en_list = ['DR.(Male)', 'DR.(Female)', 'D.D.S.(Male)', 'D.D.S.(Female)', 'female pharmacist', 'male pharmacist']
            const title_special_en = title_special_en_list[title_special_th_list.indexOf(members.title_special_th)]

            await axios({
                method: 'POST',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/doctor/preregister`,
                data: {
                    employee_id: members.employee_id.toString(),
                    account_title_th: members.title_th.replace(nonThaiPattern, ''),
                    special_title_th: members.title_special_th.replace(nonThaiPattern, ''),
                    first_name_th: members.name_th.replace(nonThaiPattern, ''),
                    last_name_th: members.surname_th.replace(nonThaiPattern, ''),
                    account_title_eng: title_en.replace(nonEnglishPattern, ''),
                    special_title_eng: title_special_en.replace(nonEnglishPattern, ''),
                    first_name_eng: members.name_eng.replace(nonEnglishPattern, ''),
                    last_name_eng: members.surname_eng.replace(nonEnglishPattern, ''),
                    id_card_num: members.cid,
                    email: members.email,
                    mobile_no: members.mobile ?? members.tel,
                    biz_id: business_id,
                    address: members.address,
                    position: members.position,
                    contract_no: objective.includes('เลขที่หนังสือสัญญา') ? members.contract_no : null
                }
            }).then(async ({ data }) => {
                prepare.push({ request: { ...members, key: v4() }, response: data })
                setTotalMember(totalMember + 1)
                setcount(index + 1)
            }, ({ response }) => {
                prepare_fail.push({ request: { ...members, key: v4() }, response: response.data })
                setcount(index + 1)
            })
        }
        dispatch(setMemberSuccess({
            member_success: [...statesuccessone, ...prepare]
        }))
        dispatch(setMemberFail({
            member_fail: [...prepare_fail]
        }))
        setStateAllOne([...prepare, ...prepare_fail])
    }

    useEffect(() => {
        if (step !== 'success') {
            if (objective.includes('CA')) {
                if ((countCA / statesuccessone.length) * 100 === 100) {
                    setActiveStep(2)
                    setTimeout(() => {
                        setStep('success')
                        setModalBeforeSuccess(true)
                        setActiveStep(3)
                    }, 1500)
                } else if (statesuccessone.length === 0 && statefailone.length === stateAllOne.length && stateAllOne.length !== 0) {
                    setActiveStep(2)
                    setTimeout(() => {
                        setStep('success')
                        setModalBeforeSuccess(true)
                        setActiveStep(3)
                    }, 1500)
                }
            } else {
                if (statesuccessone.length + statefailone.length === member.length && member.length !== 0) {
                    setActiveStep(2)
                    setTimeout(() => {
                        setStep('success')
                        setModalBeforeSuccess(true)
                        setActiveStep(3)
                    }, 1500)
                }
            }
        }
        didMountRef.current = true;
    }, [countCA, statesuccessone, statefailone, stateAllOne])
    useEffect(() => {
        if (modalbeforeSuccess) {
            sendExcelSummary()
        }
    }, [modalbeforeSuccess])

    useEffect(() => {
    }, [step])
    const createCA = async () => {
        let prepare_ca_success = []
        let prepare_ca_fail = []
        if (statesuccessone.length === 0) {
            setActiveStep(2)
            setTimeout(() => {
                setStep('success')
                // setModalBeforeSuccess(true)
                setActiveStep(3)
            }, 1500)
        } else {
            for (const index of statesuccessone.keys()) {
                await axios({
                    method: 'POST',
                    url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/ca`,
                    data: {
                        account_id: statesuccessone[index].response.data.account_id,
                        biz_id: business_id,
                        address: statesuccessone[index].request.address,
                        ou: statesuccessone[index].request.sub_organization,
                        t: statesuccessone[index].request.position,
                        o: statesuccessone[index].request.organization,
                        attorney: !!statesuccessone[index].request.maintainer_name_1,
                        maintainer_name_1: statesuccessone[index].request.maintainer_name_1,
                        maintainer_surname_1: statesuccessone[index].request.maintainer_surname_1,
                        maintainer_email_1: statesuccessone[index].request.maintainer_email_1,
                        maintainer_tel_1: statesuccessone[index].request.maintainer_tel_1,
                        maintainer_name_2: statesuccessone[index].request.maintainer_name_2,
                        maintainer_surname_2: statesuccessone[index].request.maintainer_surname_2,
                        maintainer_email_2: statesuccessone[index].request.maintainer_email_2,
                        maintainer_tel_2: statesuccessone[index].request.maintainer_tel_2,
                        idCard: statesuccessone[index].request.cid ? statesuccessone[index].request.cid.toString().replaceAll(' ', '').replaceAll('-', '') : null,
                        mobile: statesuccessone[index].request.mobile ? statesuccessone[index].request.mobile.toString().replaceAll(' ', '') : null,
                        email: statesuccessone[index].request.email ? statesuccessone[index].request.email.toString().replaceAll(' ', '') : null,
                    }
                }).then(({ data, status }) => {
                    prepare_ca_success.push({ request: statesuccessone[index], response: data })
                    setcountCA(index + 1)
                }, ({ response }) => {
                    const { status } = response
                    // if(status === 401){
                    //   navigate('/')
                    // }
                    prepare_ca_fail.push({ request: statesuccessone[index], response: response.data })
                    setcountCA(index + 1)
                })
            }
            setStateSuccessCA(prepare_ca_success)
            setStateFailCA(prepare_ca_fail)
        }
    }

    useEffect(() => {
        if (stateAllOne.length === member.length && (objective.includes('CA') || objective.includes('import-excel-rama'))) {
            createCA()
        }
    }, [
        statesuccessone,
        stateAllOne
    ])
    // end function register member

    const alertManagement = () => {
        let message = `One ID`
        if (objective.includes('CA') || objective.includes('import-excel-rama')) {
            message += ', CA'
        }
        if (objective.includes('เลขที่หนังสือสัญญา')) {
            message += ' และเลขที่หนังสือสัญญา'
        }

        if (objective.includes('edu-student-pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับ นักเรียน/นักศึกษา'
        }

        if (objective.includes('edu-teacher-pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับ ครู/อาจารย์'
        }
        if (objective.includes('Pre-register')) {
            message = 'ข้อมูล Pre Registration สำหรับบุคคลากรทางการแพทย์'
        }

        if (importMemberSuccess.length !== 0) {
            return (
                <>
                    สร้าง {message} แล้ว <br />
                    {importMemberSuccess.length} รายการ จาก {file.length} รายการ
                </>
            )
        } else {
            return (
                <>
                    ไม่มีการสร้าง {message}
                </>
            )
        }

    }


    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };
    return (
        <>
            <Row>
                <Col className="d-flex justify-content-start">
                    <h3
                        style={{
                            margin: 0,
                            padding: 0,
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            // sendExcelSummary()
                            backStep()

                        }}
                    >
                        <ArrowBackIosIcon />
                        เพิ่มรายชื่อ
                    </h3>
                </Col>
            </Row>
            {/* ui steps progress */}
            <Row style={{ marginBottom: '40px', marginTop: '20px' }}>
                <Stack sx={{ width: '100%' }} spacing={4}>
                    <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                        {steps.map((label, key) => (
                            <Step key={key}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Stack>
            </Row>
            {/* end ui steps progress */}
            {
                {
                    "check": (
                        <>
                            {/* ui search */}
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Col xl={12} lg={12} md={6} sm={12} xs={12}>
                                    <h5>ค้นหา</h5>
                                </Col>
                                <Col xl={5} lg={6} md={6} sm={12} xs={12}>
                                    <Tooltip title="ค้นหาด้วยชื่อ-นามสกุล เลขบัตรประจำตัวประชาชน หรือ เลขที่หนังสือสัญญา">
                                        <Input.Group compact>
                                            <Input
                                                value={searchvalue}
                                                size="large"
                                                style={{
                                                    width: 'calc(100% - 40px)',
                                                }}
                                                placeholder="ค้นหาด้วยชื่อ-นามสกุล เลขบัตรประจำตัวประชาชน หรือ เลขที่หนังสือสัญญา"
                                                onChange={({ target }) => {
                                                    setSearchParam(target.value);
                                                }}
                                                onPressEnter={() => {
                                                    searchFunc()
                                                }}
                                                suffix={
                                                    // searchParam &&
                                                    <CloseOutlined
                                                        onClick={() => {
                                                            clearSearch()
                                                        }}
                                                        style={{
                                                            color: 'rgba(0,0,0,.45)',
                                                        }}
                                                    />
                                                }
                                            />
                                            <Button
                                                icon={<SearchOutlined />}
                                                size="large"
                                                style={{ borderRadius: '0px 4px 4px 0px' }}
                                                onClick={() => {
                                                    searchFunc()
                                                }}
                                            />
                                        </Input.Group>
                                    </Tooltip>
                                </Col>
                            </Row>
                            {/* end ui search */}
                            {/* ui table */}
                            <Form form={form} component={false}>
                                <Table
                                    locale={customLocale}
                                    components={{
                                        body: {
                                            cell: EditableCell,
                                        },
                                    }}
                                    bordered
                                    dataSource={data}
                                    columns={mergedColumns}
                                    rowClassName="editable-row"
                                    // pagination={{
                                    //     onChange: cancel,
                                    // }}
                                    scroll={{
                                        x: 1400,
                                        y: 400,
                                    }}
                                />
                            </Form>
                            {/* end ui table */}
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Col className='d-flex justify-content-start'>
                                    <ButtonMui
                                        sx={!!style.secondary_color && {
                                            borderColor: `${style.secondary_color} !important`,
                                            color: `${style.secondary_color} !important`,
                                            border: ' 1px solid'
                                        }}
                                        size='large'
                                        onClick={() => {
                                            backStep()
                                            setActiveStep(0)
                                        }}>
                                        ยกเลิก
                                    </ButtonMui>
                                </Col>
                                <Col className='d-flex justify-content-end'>
                                    <ButtonMui
                                        sx={!!style.secondary_color && {
                                            background: `${style.secondary_color} !important`,
                                            color: fontColor(style.secondary_color)
                                        }}
                                        size='large'
                                        hidden={member.length === 0}
                                        onClick={() => {
                                            preRegister()
                                            setStep('pending')
                                            setActiveStep(1)
                                        }}>
                                        ดำเนินการสร้าง <RightOutlined />
                                    </ButtonMui>
                                </Col>
                            </Row>
                        </>
                    ),
                    "pending": (
                        <>
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Col className='d-flex justify-content-center'>
                                    <Progress
                                        type="circle"
                                        percent={(count / file.length) * 100}
                                        strokeColor={{
                                            '0%': '#86DB0A',
                                            '25%': '#A4E311',
                                            '50%': '#F0F420',
                                            '70%': '#FFCC01',
                                            '100%': '#FF9801',
                                        }}
                                        format={(percent) => <> {file.length} <br /><span style={{ fontSize: '12px' }}>รายการทั้งหมด</span> </>}
                                    />
                                </Col>
                            </Row>
                            {typeTemplate.map((type, key) => {
                                if (type == 'One ID') {
                                    return (
                                        <Row key={key} style={{ marginBottom: '20px', marginTop: '20px' }}>
                                            <Col className='d-flex justify-content-center'>
                                                <Card style={{ width: '100%', boxShadow: '4px 4px 16px rgba(5, 48, 117, 0.12)' }}>
                                                    <div className='row'>
                                                        <div className='col' style={{ textAlign: 'start' }}>
                                                            <b>สร้างรายชื่อ One ID</b>
                                                        </div>
                                                        <div className='col' style={{ textAlign: 'end' }}>
                                                            <CloseOutlined />
                                                        </div>
                                                    </div>
                                                    <p style={{ paddingTop: '20px' }}>
                                                        <Progress percent={parseInt((count / file.length) * 100)} status="active" strokeColor='#53BE35' />
                                                    </p>
                                                </Card>
                                            </Col>
                                        </Row>
                                    )
                                }
                                else if (type == 'CA' || type == 'import-excel-rama') {
                                    return (
                                        <Row key={key} style={{ marginBottom: '20px', marginTop: '20px' }}>
                                            <Col className='d-flex justify-content-center'>
                                                <Card style={{ width: '100%', boxShadow: '4px 4px 16px rgba(5, 48, 117, 0.12)' }}>
                                                    <div className='row'>
                                                        <div className='col' style={{ textAlign: 'start' }}>
                                                            <b>สร้างรายชื่อ CA</b>
                                                        </div>
                                                        <div className='col' style={{ textAlign: 'end' }}>
                                                            <CloseOutlined />
                                                        </div>
                                                    </div>
                                                    <p style={{ paddingTop: '20px' }}>
                                                        {(count / file.length) * 100 === 100 ?
                                                            <Progress percent={(countCA / file.length) * 100} status="active" strokeColor='#53BE35' />
                                                            :
                                                            'รอรายการก่อนหน้าดำเนินการเสร็จ'
                                                        }
                                                    </p>
                                                </Card>
                                            </Col>
                                        </Row>
                                    )
                                }
                            })}
                        </>
                    ),
                    "success": (
                        <>
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Box sx={{ width: '100%', typography: 'body1' }}>
                                    <TabContext value={value}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary"
                                                TabIndicatorProps={{
                                                    sx: !!style.secondary_color && {
                                                        backgroundColor: `${style.secondary_color} !important`,
                                                        color: fontColor(style.secondary_color)
                                                    }
                                                }}>
                                                <Tab label={`รายการที่สำเร็จ (${importMemberSuccess.length})`} value="1" />
                                                <Tab label={`รายการที่ไม่สำเร็จ (${importMemberFail.length})`} value="2" />
                                            </TabList>
                                        </Box>
                                        <TabPanel value="1">
                                            <AddDoctorSuccess
                                                memberOneSuccess={statesuccessone}
                                            // memberCASuccess={memberCASuccess}
                                            />
                                        </TabPanel>
                                        <TabPanel value="2">
                                            <AddDoctorFail />
                                        </TabPanel>
                                    </TabContext>
                                </Box>
                            </Row>
                            <Modal
                                title={importMemberSuccess.length != 0 ? "ทำรายการสำเร็จ" : "ทำรายการไม่สำเร็จ"}
                                centered
                                open={modalbeforeSuccess}
                                onOk={() => setModalBeforeSuccess(false)}
                                onCancel={() => setModalBeforeSuccess(false)}
                                footer={null}
                            >
                                <Row>
                                    <Col className='d-flex justify-content-center'>
                                        {importMemberSuccess.length != 0 ?
                                            <CheckIcon style={{
                                                background: '#53BE35',
                                                borderRadius: '50%',
                                                fontSize: '50px',
                                                color: '#fff',
                                                padding: '10px'
                                            }} />
                                            :
                                            <CloseIcon style={{
                                                background: '#F37959',
                                                borderRadius: '50%',
                                                fontSize: '50px',
                                                color: '#fff',
                                                padding: '10px'
                                            }} />
                                        }
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: '30px', paddingBottom: '30px' }}>
                                    <Col className='d-flex justify-content-center text-center'>
                                        {alertManagement()}
                                    </Col>
                                </Row>
                            </Modal>
                        </>
                    ),
                }[step]
            }
        </>
    );
};
export default AddDoctor;